let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4zF1d")).then(() => parcelRequire('3AMQa'));